import React from 'react';
import PropTypes from 'prop-types';

import ValueView from './ValueView';
import { formatTz } from '../../../utils/timezone';
import withTranslations from '../../utils/Translations/withTranslations';
import translatePropTypes from '../../../translatePropTypes';

@withTranslations
export default class TimeZonesView extends React.PureComponent {
  static propTypes = {
    value: PropTypes.string,
    label: PropTypes.string.isRequired,
    ...translatePropTypes,
  };

  static defaultProps = {
    value: null,
  };

  render() {
    const { value, label, currentLanguage } = this.props;
    const { name } = formatTz(value, currentLanguage);
    return <ValueView label={label} value={name} />;
  }
}
